// 锁定底层页面滚动（弹窗 / 全屏预览打开期间用）。
// 带引用计数：多个弹层叠加时，只有最后一个关闭才恢复 body.overflow。
// 旧写法是每个弹层各自“记下旧值 → 设 hidden → 关闭时还原旧值”，叠加时后开的会把 'hidden'
// 当成旧值记下来，关闭顺序一乱就把 'hidden' 永久留在 body 上，页面从此无法正常滚动。
//
// 用法：useEffect(() => lockBodyScroll(), []);   // 返回的释放函数正好作为 effect 的清理函数
let count = 0;
let saved = '';

export function lockBodyScroll() {
  if (typeof document === 'undefined') return () => {};
  if (count === 0) {
    saved = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  count += 1;
  let released = false;
  return () => {
    if (released) return;          // 同一个锁重复释放不重复扣减
    released = true;
    count = Math.max(0, count - 1);
    if (count === 0) {
      document.body.style.overflow = saved;
      saved = '';
    }
  };
}
